import React, { useState, useEffect } from "react";
import { apiUrl, brands } from "../config/config";
import { setStorage } from "../utils/storage";
import { useNavigate } from "react-router-dom";
import SEO from "./SEO";
import signupImage from "../assets/signup.png";
function Signup() {
  const [showPass, setShowPass] = useState(false);
  const [showConfirmPass, setShowConfirmPass] = useState(false);
  const navigate = useNavigate();

  const [form, setForm] = useState({
    name: "",
    email: "",
    password: "",
    confirmPassword: "",
  });

  const [loading, setLoading] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [successMsg, setSuccessMsg] = useState("");

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      window.location.href = "/account";
    }
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg("");
    setSuccessMsg("");

    if (form.password !== form.confirmPassword) {
      setErrorMsg("Passwords do not match!");
      return;
    }
    setLoading(true);

    try {
      const res = await fetch(`${apiUrl}/api/register`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: form.email,
          password: form.password,
          brand: brands,
        }),
      });

      const data = await res.json();

      if (!res.ok) {
        setErrorMsg(data.message || "Registration failed");
      } else {
        setSuccessMsg("Account created successfully!");
        setStorage("user", data.user);
        window.location.href = "/";
        setForm({
          name: "",
          email: "",
          password: "",
          confirmPassword: "",
        });
      }
    } catch (err) {
      setErrorMsg("Something went wrong, try again!");
    }

    setLoading(false);
  };

  return (
    <>
      <SEO
        title="Sign up"
        description="Shirts Patches"
        keywords="Shirts Patches"
      />

      <div className="min-h-screen bg-lightPastelPurple px-4 py-10 sm:px-6 lg:px-8">
        <div className="mx-auto flex min-h-[calc(100vh-90px)] max-w-7xl items-center justify-center">
          <div className="grid w-full overflow-hidden rounded-[30px] border border-pastelPurple bg-white shadow-[0_22px_60px_rgba(47,34,84,0.10)] lg:grid-cols-2">
            <div className="relative flex min-h-[260px] items-center justify-center overflow-hidden bg-gradient-to-br from-[#f2ecff] via-white to-[#f8ffe0] p-6 md:min-h-[340px] lg:min-h-full">
              <div className="absolute -left-20 -top-20 h-72 w-72 rounded-full bg-pastelPurple/70 blur-3xl"></div>
              <div className="absolute -right-20 -bottom-20 h-72 w-72 rounded-full bg-keyLime/25 blur-3xl"></div>

              <div className="relative flex h-full w-full items-center justify-center rounded-[26px] border border-white/80 bg-white/50 p-8 backdrop-blur-sm">
                <img
                  src={signupImage}
                  alt="Signup"
                  className="max-h-[300px] w-full max-w-[360px] object-contain drop-shadow-[0_18px_28px_rgba(33,27,51,0.16)]"
                />
              </div>
            </div>

            <div className="relative overflow-hidden bg-white p-5 md:p-7 lg:p-9">
              <div className="absolute -right-24 -top-24 h-72 w-72 rounded-full bg-pastelPurple/50 blur-3xl"></div>
              <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-keyLime/20 blur-3xl"></div>

              <div className="relative mx-auto max-w-md">
                <div className="text-center">
                  <h2 className="text-3xl font-extrabold leading-tight tracking-tight text-darkPurple md:text-4xl">
                    Create Account
                  </h2>

                  <div className="mx-auto mt-4 flex w-full max-w-[210px] items-center justify-center gap-3">
                    <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
                    <span className="h-2.5 w-2.5 rounded-full bg-keyLime shadow-[0_0_0_5px_rgba(215,255,79,0.25)]"></span>
                    <span className="h-[1px] flex-1 bg-[#d8c8ff]"></span>
                  </div>

                  <p className="mt-5 text-base font-medium leading-7 text-[#5f5870]">
                    Join us and get started!
                  </p>
                </div>

                {errorMsg && (
                  <div className="mt-6 rounded-2xl border border-red-200 bg-red-50 px-5 py-4 text-center text-sm font-bold text-red-700">
                    {errorMsg}
                  </div>
                )}

                {successMsg && (
                  <div className="mt-6 rounded-2xl border border-green-200 bg-green-50 px-5 py-4 text-center text-sm font-bold text-green-700">
                    {successMsg}
                  </div>
                )}

                <form className="mt-7 space-y-5" onSubmit={handleSubmit}>
                  <div>
                    <label className="mb-2 block text-sm font-extrabold text-darkPurple">
                      Full Name
                    </label>

                    <input
                      type="text"
                      placeholder="John Doe"
                      name="name"
                      value={form.name}
                      onChange={handleChange}
                      className="w-full rounded-2xl border border-pastelPurple bg-lightPastelPurple px-5 py-3.5 text-base font-medium text-darkPurple outline-none transition focus:border-themePurple focus:bg-white focus:ring-4 focus:ring-pastelPurple/60"
                    />
                  </div>

                  <div>
                    <label className="mb-2 block text-sm font-extrabold text-darkPurple">
                      Email Address
                    </label>

                    <input
                      type="email"
                      name="email"
                      value={form.email}
                      onChange={handleChange}
                      placeholder="you@example.com"
                      className="w-full rounded-2xl border border-pastelPurple bg-lightPastelPurple px-5 py-3.5 text-base font-medium text-darkPurple outline-none transition focus:border-themePurple focus:bg-white focus:ring-4 focus:ring-pastelPurple/60"
                    />
                  </div>

                  <div>
                    <label className="mb-2 block text-sm font-extrabold text-darkPurple">
                      Password
                    </label>

                    <div className="relative">
                      <input
                        type={showPass ? "text" : "password"}
                        name="password"
                        value={form.password}
                        onChange={handleChange}
                        placeholder="Create a password"
                        className="w-full rounded-2xl border border-pastelPurple bg-lightPastelPurple px-5 py-3.5 pr-14 text-base font-medium text-darkPurple outline-none transition focus:border-themePurple focus:bg-white focus:ring-4 focus:ring-pastelPurple/60"
                      />

                      <button
                        type="button"
                        onClick={() => setShowPass(!showPass)}
                        className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-xl bg-white text-sm shadow-sm transition hover:bg-keyLime"
                      >
                        {showPass ? "🙈" : "👁️"}
                      </button>
                    </div>
                  </div>

                  <div>
                    <label className="mb-2 block text-sm font-extrabold text-darkPurple">
                      Confirm Password
                    </label>

                    <div className="relative">
                      <input
                        type={showConfirmPass ? "text" : "password"}
                        name="confirmPassword"
                        value={form.confirmPassword}
                        onChange={handleChange}
                        placeholder="Re-enter password"
                        className="w-full rounded-2xl border border-pastelPurple bg-lightPastelPurple px-5 py-3.5 pr-14 text-base font-medium text-darkPurple outline-none transition focus:border-themePurple focus:bg-white focus:ring-4 focus:ring-pastelPurple/60"
                      />

                      <button
                        type="button"
                        onClick={() =>
                          setShowConfirmPass(!showConfirmPass)
                        }
                        className="absolute right-3 top-1/2 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-xl bg-white text-sm shadow-sm transition hover:bg-keyLime"
                      >
                        {showConfirmPass ? "🙈" : "👁️"}
                      </button>
                    </div>
                  </div>

                  <button
                    type="submit"
                    disabled={loading}
                    className="w-full rounded-2xl bg-keyLime px-7 py-3.5 text-center text-sm font-extrabold text-darkPurple shadow-[0_12px_26px_rgba(215,255,79,0.35)] transition-all duration-300 hover:-translate-y-0.5 hover:bg-[#c8f531] disabled:cursor-not-allowed disabled:opacity-60"
                  >
                    {loading ? "Creating Account..." : "Create Account"}
                  </button>
                </form>

                <p className="mt-6 text-center text-sm font-medium text-[#5f5870]">
                  Already have an account?{" "}
                  <a
                    href="/login"
                    className="font-extrabold text-themePurple transition hover:text-darkPurple hover:underline"
                  >
                    Login
                  </a>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Signup;
